export default __webpack_public_path__ + "static/media/Herbstbild_Munich.f81dd2b7.webp";